import { Instagram, Facebook } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { CLUB, SPONSORS } from "@/data/content";

export default function Footer() {
  const go = (t) => scrollToId(t);

  return (
    <footer data-testid="main-footer-section" className="bg-[#070911] text-white/70 border-t border-[#1E2638]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <p className="text-center text-xs font-bold uppercase tracking-widest text-white/40">Le aziende che ci sostengono</p>
        <div data-testid="sponsors-logos-grid" className="mt-5 flex flex-wrap justify-center gap-3 md:gap-4">
          {SPONSORS.map((s) => (
            <span key={s} className="cursor-pointer rounded-lg border border-[#1E2638] bg-[#131822] px-4 py-2 text-sm font-semibold text-white/60 transition-colors duration-300 hover:bg-white hover:text-[#0B0E14] hover:border-white">
              {s}
            </span>
          ))}
        </div>
      </div>

      <div className="border-t border-[#1E2638]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src={CLUB.logo} alt="Logo" className="h-14 w-auto" />
              <span className="font-display font-extrabold uppercase leading-none text-white">
                Inter Club<br /><span className="text-primary">Guardialfiera</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed">{CLUB.tagline}.</p>
            <p className="mt-3 text-sm leading-relaxed text-white/50">{CLUB.address}</p>
            <p className="mt-1 text-sm text-white/50">C.F. 91062570709</p>
          </div>

          <div>
            <h4 className="font-display font-bold uppercase text-white mb-4">Naviga</h4>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
              {[["Chi Siamo", "#chi-siamo"], ["Direttivo", "#direttivo"], ["Vieni allo Stadio", "#stadio"], ["Tesseramento", "#tesseramento"], ["News", "#news"], ["Galleria", "#galleria"], ["Contatti", "#contatti"]].map(([l, t]) => (
                <li key={t}>
                  <button onClick={() => go(t)} className="hover:text-gold transition-colors">{l}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold uppercase text-white mb-4">Seguici</h4>
            <div className="flex gap-3">
              <a href={CLUB.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-[#1E2638] hover:border-gold hover:text-gold transition-colors"><Instagram size={18} /></a>
              <a href={CLUB.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="flex h-10 w-10 items-center justify-center rounded-full border border-[#1E2638] hover:border-gold hover:text-gold transition-colors"><Facebook size={18} /></a>
            </div>
            <p className="mt-4 text-sm">{CLUB.email}</p>
          </div>
        </div>
      </div>

      <div className="border-t border-[#1E2638] py-5">
        <p className="text-center text-xs text-white/50 px-4">
          © {new Date().getFullYear()} {CLUB.name} — C.F. 91062570709 · Tutti i diritti riservati.
        </p>
        <p className="mt-1 text-center text-[11px] text-white/30 px-4">
          Sito non ufficiale realizzato dai tifosi. FC Internazionale Milano è un marchio registrato dei rispettivi proprietari.
        </p>
      </div>
    </footer>
  );
}
